import React from 'react'
import UnderlinedTitle from '../../shared/underlinedText/underlined-title'
import Text from '../../shared/textStyleDefault/texto'

const Enfoque = (): any => {
  return (
    <div className='flex flex-col w-full md:w-[80%] pt-[55px] md:[157px] pb-[55px] mx-auto max-w-[1230px] px-1'>
        <UnderlinedTitle blanco={false} marginLeft={false} marginTop='0px' palabrasSubrayadas='Enfoque' texto='Enfoque' width='100%'></UnderlinedTitle>
        <Text as='h6' className='font-light text-left w-full xl:w-[50%] pt-3 mt-3'>
            Gestionar productos no es una lista de tareas.<br />
            - Es tomar decisiones complejas, con foco y propósito.<br />
            - Es entender el problema antes de escribir una línea de código.<br />
            - Es escuchar, priorizar, y construir lo que realmente importa.<br /><br />
            En Criterian, gestrionamos productos digitales con una visión estratégica clara y capacidad real de ejecución. Este es nuestro enfoque.
        </Text>
    </div>
  )
}
export default Enfoque
